import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import BufferOptionsItem from 'buffers/BufferOptionsItem';
import {SimplifiedLinearSequenceOptionsProps} from 'molbio/maps/options/LinearSequenceOptionsView';
import MapSelector from 'molbio/maps/options/MapSelector';
import {ZoomSlider} from 'molbio/maps/options/Sliders';
import DisplayOptions from 'settings/visibility-options/DisplayOptions';

export default function SimplifiedLinearOptions({
  isOligo,
  mapType,
  onSelectMapType,
  isCircular,
  zoomSliderProps,
  visibilityOptions,
  featureCounts,
}: SimplifiedLinearSequenceOptionsProps): JSX.Element {
  return (
    <div className="buffer-options-container">
      <BufferOptionsItem>
        {!isOligo && (
          <MapSelector mapType={mapType} onSelectMapType={onSelectMapType} isCircular={isCircular} />
        )}
      </BufferOptionsItem>
      <BufferOptionsItem>{!isOligo && <ZoomSlider {...zoomSliderProps} />}</BufferOptionsItem>
      <BufferOptionsItem className={css(styles.expander)} />
      <BufferOptionsItem className="u-vertical-center-items">
        <DisplayOptions dropLeft={true} options={visibilityOptions} featureCounts={featureCounts} />
      </BufferOptionsItem>
    </div>
  );
}

const styles = StyleSheet.create({
  expander: {
    // Normally the banner has a flex value so it expands and pushes the DisplayOptions and SearchButton
    // all the way to the right.
    flex: 1,
  },
});
